<template>
  <div>
    <p v-for="item in orders" :key="item.id" :value="item.id">
      {{ item }}
    </p>
  </div>
</template>

<script>
export default {

  name: 'listOrders',

  props: {
    orders: Array,
  },

  data() {
    return {
    };
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/Purchases/Freight/FreightOrders.vue